<template>
  <div
    v-show="visible"
    class="cbbfixed"
    style="bottom: 10px;"
    @click="backToTop"
  >
    <tk-link class="gotop cbbtn">
      <span class="up-icon"></span>
    </tk-link>
  </div>
</template>

<script>
import TkLink from '../../atoms/TkLink/TkLink'

const getScrollTop = () =>
  document.documentElement.scrollTop || document.body.scrollTop
const getScrollLeft = () =>
  document.documentElement.scrollLeft || document.body.scrollLeft

export default {
  name: 'TkScrollToTop',
  components: {
    TkLink,
  },
  props: {
    visibleOffset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    window.smoothScroll = () => {
      const currentScrollTop = getScrollTop()
      if (currentScrollTop > 0) {
        window.requestAnimationFrame(window.smoothScroll)
        window.scrollTo(getScrollLeft(), 0)
      }
    }
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.visible = getScrollTop() > this.visibleOffset
    },
    backToTop() {
      window.smoothScroll()
    },
  },
}
</script>
